import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formControlAutoComplete: {
        margin: "10px"
    },
    formControl: {
        minWidth: "60%",
        margin: "10px",
    },
    input: {
        padding: "5px",
    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "top"
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
      paddingPaper:{
        paddingBottom: theme.spacing(2),
        minHeight:"100%",
        height:"100%"
    },
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        marginTop: "10px",
      },
      datePicker: {
        minWidth: "100%",
        marginTop: theme.spacing(2),
      },

    buttonZeitraum:{
        "&.Mui-selected":{
            backgroundColor: theme.palette.secondary.main + "!important",
            color: "black" + "!important",
            borderColor: theme.palette.secondary.main + "!important"
        }
    },

    disabledColor: {
        "&.Mui-disabled":{
            backgroundColor: theme.palette.grey[200] + "!important",
            color: "black" + "!important",
            borderColor: theme.palette.grey[400] + "!important"
        }
    },

    textFieldBorder: {
        borderColor: theme.palette.grey[200] + "!important",
        "& .MuiOutlinedInput-root": {
            borderColor: theme.palette.grey[200] + "!important",
            "&:active": {
                borderColor: theme.palette.grey[200] + "!important",
            },
            "&:hover": {
                borderColor: theme.palette.grey[200] + "!important",
            },
        },
        "& .MuiTextField-root": {
            borderColor: theme.palette.grey[200] + "!important",
            "&:active": {
                borderColor: theme.palette.grey[200] + "!important",
            },
            "&:hover": {
                borderColor: theme.palette.grey[200] + "!important",
            },
        }
    },
    
    marks: {
        fontSize:"large",
        markLabel:{
            fontSize:"60px"
        },
        "& .MuiSlider-markLabel":{
            fontSize:"1.2rem"
        },
    }

}), {index: 1});